<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    :click-not-close="true"
    class="add-role-dialog"
  >
    <div class="form-content">
      <table-form
        :form-data="formData"
        :key="formData.id"
        ref="outform"
        @submit="submit"
      ></table-form>
    </div>
  </sliderBarDialogShell>
</template>

<script>
import tableForm from "@/components/sys/dataPermission/table-list/tableForm";
import { updateTable} from "@/api/sys/dataPermission/tableList";

export default {
  name: "editTableDialog",
  components: {
    tableForm,
  },
  props: {
    formData:{
      type: Object,
    },
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '编辑',
    }
  },
  watch:{
    dialogShow(newValue){
      if(newValue){
        setTimeout(() => {
          this.$refs.outform && this.$refs.outform.assigen(this.formData);
        },200);
      }
    },
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    submit(form) {
      let params = {
        ...form,
      }
      updateTable(params).then((data) => {
        if(data && data.code===200){
          this.$message({
            message: '编辑成功',
            type: 'success',
          });
          this.$refs.outform.selfClear();
          this.$emit('add-success');
        }else{
          this.$message({
            message: data.msg,
            type: 'error'
          });
        }
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>

<style scoped>

</style>
